import { defaultFill } from '../../../../utils/constants';
var muiPlaySquareFill16 = {
    paths: [
        {
            path: 'M14.9991283,0 C15.5518945,0 16,0.455760956 16,1.00247329 L16,10.9975267 C16,11.5511774 15.5553691,12 14.9991283,12 L1.00087166,12 C0.448105505,12 0,11.544239 0,10.9975267 L0,1.00247329 C0,0.448822582 0.444630861,0 1.00087166,0 L14.9991283,0 Z M6.14524695,3.12515761 C6.04399147,3.21315208 5.99583187,3.32870913 6.00028232,3.44270915 L6.0009952,3.52481666 C6.00387604,4.18079582 6.00074333,8.46994199 6.00123201,8.57254129 C6.00175086,8.681475 6.04954321,8.79060562 6.14524695,8.87377544 C6.33886834,9.04203905 6.64846161,9.04158237 6.83973705,8.87535747 L10.5766633,6.52738488 C11.04023,6.23611825 11.0415282,5.76461012 10.5766633,5.47241943 L6.83973705,3.12357558 C6.65039428,2.95903024 6.3375278,2.95805898 6.14524695,3.12515761 Z',
            fill: defaultFill,
        },
    ],
    title: 'Play',
    width: 16,
    height: 12,
};
var muiPlaySquareFill = {
    base: muiPlaySquareFill16,
    smIcon: muiPlaySquareFill16,
};
export { muiPlaySquareFill };
//# sourceMappingURL=playSquareFill.js.map